/** Feeder-scoped protective-device picker for the source-device OVERRIDE (spec
 *  §4.2). The platform /search has no protective-device type, so this reads the
 *  dedicated GET /oms/feeders/{id}/protective-devices. A plain select — the device
 *  list per feeder is small. */

import { useFeederProtectiveDevices } from '../../hooks/useOms.ts'

export function SourceDevicePicker({
  feederId,
  value,
  onChange,
}: {
  feederId: number | null
  value: number | null
  onChange: (deviceId: number | null) => void
}) {
  const { data, isLoading, isError } = useFeederProtectiveDevices(feederId)

  if (feederId === null) {
    return (
      <div className="text-xs text-gray-400">
        No single feeder could be resolved for this outage (meter / substation
        scope) — override unavailable.
      </div>
    )
  }
  if (isLoading) {
    return <div className="text-xs text-gray-400">Loading devices…</div>
  }
  if (isError) {
    return <div className="text-xs text-red-600">Failed to load feeder devices.</div>
  }
  const devices = data ?? []
  return (
    <select
      value={value ?? ''}
      onChange={e => onChange(e.target.value ? Number(e.target.value) : null)}
      className="mt-1 w-full text-sm border border-gray-300 rounded-md px-2 py-1.5"
    >
      <option value="">-- pick a device --</option>
      {devices.map(d => (
        <option key={d.id} value={d.id}>
          {d.name ?? d.gis_id ?? `device #${d.id}`} · {d.device_type}
        </option>
      ))}
    </select>
  )
}
